import { Component, Vue } from 'nuxt-property-decorator';

@Component
export default class TextOutput extends Vue {
  filterSymbol(symbol: string) {
    const tSymb = this.$t('common.transactions.gyri') as string;
    return symbol.replace(/gyri/i, tSymb);
  }
}
